import { computed } from 'vue'
import type { Deliverable, DeliverableType } from '@/types'
import type { DeliverablesState } from './state'

export const createGetters = (state: DeliverablesState) => {
  const filteredDeliverables = computed(() => {
    let result = [...state.deliverables]

    if (state.filters.search) {
      const search = state.filters.search.toLowerCase()
      result = result.filter(
        (d) =>
          d.name.toLowerCase().includes(search) ||
          d.description?.toLowerCase().includes(search)
      )
    }

    if (state.filters.projectId) {
      result = result.filter((d) => d.projectId === state.filters.projectId)
    }

    if (state.filters.type) {
      result = result.filter((d) => d.type === state.filters.type)
    }

    if (state.filters.status) {
      result = result.filter((d) => d.status === state.filters.status)
    }

    return result
  })

  const deliverablesByProject = computed(() => {
    const grouped: Record<string, Deliverable[]> = {}
    filteredDeliverables.value.forEach((d) => {
      if (!grouped[d.projectId]) {
        grouped[d.projectId] = []
      }
      grouped[d.projectId].push(d)
    })
    return grouped
  })

  const deliverablesByType = computed(() => {
    const grouped: Record<string, Deliverable[]> = {}
    state.deliverables.forEach((d) => {
      if (!grouped[d.type]) {
        grouped[d.type] = []
      }
      grouped[d.type].push(d)
    })
    return grouped
  })

  const getByProject = (projectId: string) =>
    computed(() => state.deliverables.filter((d) => d.projectId === projectId))

  const getByType = (type: DeliverableType) =>
    computed(() => state.deliverables.filter((d) => d.type === type))

  return {
    filteredDeliverables,
    deliverablesByProject,
    deliverablesByType,
    getByProject,
    getByType,
  }
}
